import t_19_2321_colorized from './KZ.T.19.2321.svg'
import t_19_2321 from './KZ.T.19.2321 black.svg'

export default [
  t_19_2321_colorized,
  t_19_2321
]
